<template>
  <v-col cols="12" sm="12" md="8" class="d-flex">
    <v-card class="elevation-1 flex-grow-1">
      <v-toolbar
        color="white"
        flat
        :class="{ 'cta-blurred-card': isCallToActionWidget }"
      >
        <v-toolbar-title class="text-md-subtitle-1">
          <span>Referral Progression</span>
          <v-btn
            icon="fa-regular fa-circle-info"
            variant="text"
            aria-label="info"
            color="btncolor"
            @click="showToolTip"
          >
          </v-btn>
        </v-toolbar-title>
      </v-toolbar>
      <v-container
        fluid
        class="lead-progression-table-container"
        :class="{ 'cta-blurred-card': isCallToActionWidget }"
      >
        <v-row v-if="loading" align="center" justify="center">
          <v-col class="pt-0">
            <div class="dashboard-widget-progress-container">
              <v-progress-circular
                :size="75"
                :width="8"
                class="my-auto"
                color="primary"
                indeterminate
              />
            </div>
          </v-col>
        </v-row>

        <v-row v-else class="pt-0">
          <overview-referral-progression-clear-component
            v-if="leads.length === 0"
          />

          <v-data-table-server
            v-else
            class="elevation-0 lead-progression-table"
            :headers="headers"
            :items="leads"
            :items-length="totalLeads"
            :loading="loading"
            :mobile="false"
          >
            <template #item="props">
              <overview-referral-progression-list-row
                :is-call-to-action-widget="isCallToActionWidget"
                :lead.sync="props.item"
                @view="viewLead"
              />
            </template>
            <!-- remove bottom pagination -->
            <template #bottom></template>
          </v-data-table-server>
        </v-row>
      </v-container>
      <v-divider v-if="!isCallToActionWidget" />
      <v-card-actions v-if="!isCallToActionWidget && !loading">
        <v-spacer />
        <v-btn
          variant="text"
          class="text-none"
          color="btncolor"
          @click="viewMyLeads"
        >
          See All IRIS Progression
        </v-btn>
      </v-card-actions>

      <overview-call-to-action-widget
        v-if="isCallToActionWidget"
        :cta-text="ctaText"
        :title="dialogTitle"
        :description="dialogDescription"
        class="call-to-action-widget"
      />
    </v-card>

    <component
      v-if="myLeadDetails && selectedOpportunity"
      parent=""
      :is="myLeadDetails"
      :opportunityId="selectedOpportunity.id"
      @closed="closeLeadView"
    />
  </v-col>
</template>

<script>
import api from "@/services/api.js";
// import { authMixin } from "@/mixins/auth.js";
import { mapGetters, mapMutations } from "vuex";
import MyLeadDetails from "@/components/console/my-leads/MyLeadDetails";
import OverviewReferralProgressionListRow from "@/components/console/dashboard/OverviewReferralProgressionListRow";
import OverviewCallToActionWidget from "@/components/console/dashboard/OverviewCallToActionWidget";
import C from "@/utils/constants";
import useAuthMixin from "@/mixins/auth.js";

export default {
  name: "console-overview-referral-progression",
  components: {
    OverviewCallToActionWidget,
    MyLeadDetails,
    OverviewReferralProgressionListRow,
    OverviewReferralProgressionClearComponent: () =>
      import("./OverviewReferralProgressionClearComponent"),
  },
  props: {
    isCallToActionWidget: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogTitle: "",
      dialogDescription: "",
      ctaText: "",
      myLeadDetails: null,
      loading: true,
      headers: [
        {
          title: "Name",
          value: "name",
          key: "name",
          sortable: false,
          align: "start",
          width: "40%",
        },
        {
          title: "Status",
          value: "status",
          key: "status",
          sortable: false,
          align: "start",
          width: "20%",
        },
        {
          title: "SMS",
          value: "sms",
          key: "sms",
          sortable: false,
          align: "start",
          width: "15%",
        },
        {
          title: "Calls",
          value: "calls",
          key: "calls",
          sortable: false,
          align: "start",
          width: "15%",
        },
      ],
      leads: [],
      totalLeads: 0,
      toolTip: null,
      toolTipDialog: false,
      selectedOpportunity: null,
    };
  },
  // mixins: [authMixin],
  computed: {
    ...mapGetters("user", ["myBrokerage"]),
    ...mapGetters("auth", ["impBrokerage"]),
  },
  methods: {
    ...useAuthMixin(),
    ...mapMutations("user", ["setMyAgentsSort", "setMyAgentsSortDesc"]),
    async loadLeads() {
      this.loading = true;
      let params = {
        pageIndex: 0,
        pageSize: 5,
        sort: "created,DESC",
      };

      try {
        let { data } = await api.interviews.getBrokerLeads(params);
        this.leads = data.content;
        this.totalLeads = data.totalElements;
      } catch (e) {
        this.errorCheck(e);
      } finally {
        this.loading = false;
      }
    },
    showToolTip() {
      this.$emit("toolTip", "OverviewReferralProgressionToolTip");
    },
    viewMyLeads() {
      this.$router.push({
        name: "my-leads",
      });
    },
    viewLead(lead) {
      if (lead.opportunity && lead.opportunity.id) {
        this.selectedOpportunity = lead.opportunity;
        this.myLeadDetails = MyLeadDetails;
      }
    },
    closeLeadView() {
      this.selectedOpportunity = null;
      this.myLeadDetails = null;
    },
  },
  mounted() {
    if (!this.isCallToActionWidget) {
      this.loadLeads();
    } else {
      console.log("I AM HERE");
      this.loading = false;
      this.leads = [...C.REFERRAL_PROGRESSION_DUMMY_DATA];
      this.ctaText = C.REFERRAL_PROGRESSION_CTA_TEXT;
      this.dialogTitle = "Referral Progression";
      this.dialogDescription = C.REFERRAL_PROGRESSION_CTA_DESCRIPTION;
    }
  },
};
</script>

<style scoped>
.call-to-action-widget {
  width: 100%;
  position: absolute;
  bottom: 0;
}
.cta-blurred-card {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  filter: blur(4px);
  opacity: 0.7;
  pointer-events: none;
}

.lead-progression-table-container {
  min-height: 420px;
}

.lead-progression-table >>> table {
  width: 100%;
  /*min-height: 420px;*/
  table-layout: fixed;
}
.lead-progression-table >>> table thead tr th {
  border-bottom: none !important;
  border-top: none !important;
  border-color: #ffffff !important;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}
.lead-progression-table >>> .th-10 {
  width: 10%;
}
.lead-progression-table >>> .th-25 {
  width: 25%;
}

/* set the header to 100% once in the sm and below breakpoints */
@media only screen and (max-width: 959px) {
  .lead-progression-table >>> .name-th {
    width: 100%;
  }
}

.lead-progression-table >>> th.active {
  color: #4a90e2 !important;
  font-weight: 600 !important;
}

.lead-progression-table >>> table tbody tr {
  font-size: 14px !important;
}
.lead-progression-table >>> table tbody tr td {
  border-bottom: none !important;
  border-top: none !important;
  border-color: #ffffff !important;
  font-size: 14px !important;
  height: 73px !important;
}

/*.lead-progression-table .v-table tbody tr {*/
/*  border-bottom: none !important;*/
/*  height: 65px;*/
/*}*/
/*.lead-progression-table >>> .theme--light.v-table thead,*/
/*.lead-progression-table >>> .theme--light.v-table thead tr:first-child {*/
/*  border-bottom: none !important;*/
/*}*/
/*.lead-progression-table >>> .theme--light.v-table tbody {*/
/*  box-shadow: none !important;*/
/*  -webkit-box-shadow: none !important;*/
/*}*/
/*.lead-progression-table >>> .v-table thead tr th {*/
/*  font-size: 16px !important;*/
/*  font-weight: 500 !important;*/
/*  !*padding: 0 4px 4px 4px !important;*!*/
/*}*/
/*.lead-progression-table >>> .v-table tbody tr {*/
/*  border-bottom: none !important;*/
/*  border-color: #ffffff !important;*/
/*}*/
/*.lead-progression-table .v-table tbody tr td {*/
/*  font-size: 14px;*/
/*  font-weight: 400;*/
/*  padding: 0 4px 16px 4px !important;*/
/*}*/
/*.lead-progression-table .v-table tbody tr:not(:first-child) td {*/
/*  !*padding-top: 16px !important;*!*/
/*}*/
/*.lead-progression-table >>> .v-table tbody tr:hover {*/
/*  background-color: #f5f5f5 !important;*/
/*}*/

.v-data-table {
  background: transparent;
}
.v-data-table :deep(.v-data-table-header__sort-icon) {
  font-size: unset;
  margin-left: 4px;
}

.v-data-table :deep(.v-data-table-header__content) {
  font-weight: 400;
}

/* Style specific table headers */
/* Status header */
:deep(table th:not(:last-child :first-child)) {
  padding-left: 4px !important;
}

/* Slotted header hover sort handling */
:deep(table th .header-hover:hover .header-icon) {
  opacity: 0.5 !important;
  font-size: unset;
  margin-left: 4px;
}
:deep(table th .header-hover .header-icon) {
  opacity: 0;
}
:deep(table th.v-data-table__th--sorted .header-hover .header-icon) {
  opacity: 1 !important;
  font-size: unset;
  margin-left: 4px;
}
:deep(table th.v-data-table__th--sorted:hover .header-hover .header-icon) {
  opacity: 1;
  font-size: unset;
  margin-left: 4px;
}
</style>
